// extracted by mini-css-extract-plugin
module.exports = {"layer_title":"LayerTitle_layer_title__RDISC","align-left":"LayerTitle_align-left__KNLqG","title":"LayerTitle_title__WVxqH","count":"LayerTitle_count__2lbVN"};